<template>
  <article class="flight-component">
    <header class="row header">
      <div class="header__item">
        <span v-if="flight.departureDate">
          {{ flight.departureDate | formatDateWithSeparators }}
        </span>
      </div>
      <div class="header__item">{{ flight.flightNumber }}</div>
    </header>
    <div :class="{ 'no-button': readOnly }" class="row main">
      <div class="airport">
        <div class="code">{{ flight.departureAirportIATA }}</div>
        <div class="city">{{ flight.departureAirportCity }}</div>
      </div>
      <icon class="plane-icon" name="plane" />
      <div class="airport">
        <div class="code">{{ flight.arrivalAirportIATA }}</div>
        <div class="city">{{ flight.arrivalAirportCity }}</div>
      </div>
    </div>
    <div v-if="!readOnly" class="buttons">
      <button-component yellow @click="handleAddPassanger">
        {{ $t('add-request') }}
      </button-component>
      <button-component
        :to="{ name: 'requests-history', params: { flightId: flight.id } }"
        :badge="errorsCount"
        tag="router-link"
        green
      >
        {{ $t('requests-history') }}
      </button-component>
    </div>
  </article>
</template>

<script>
import ButtonComponent from '@/components/Button'
import { LeadStatus } from '@/constants'

export default {
  components: {
    ButtonComponent
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    flight: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    errorsCount() {
      return this.$store.getters.failedLeads.filter(
        lead =>
          lead.data.flight === this.flight.id &&
          [LeadStatus.FAILED, LeadStatus.INTERRUPTED].includes(lead.status)
      ).length
    }
  },
  methods: {
    handleAddPassanger() {
      localStorage.setItem('flight', JSON.stringify(this.flight))
      this.$router.push({ name: 'add-case' })
    }
  }
}
</script>

<style lang="scss" scoped>
.flight-component {
  display: flex;
  flex-direction: column;
  padding: 22px;
  background: #fff;
  box-shadow: $box-shadow-dark;
  border-radius: $border-radius;
  width: calc(50% - 5px);
  margin-bottom: 22px;

  @media (max-width: 670px) {
    width: 100%;
  }
}

.row {
  display: flex;
  justify-content: space-between;
}

.header {
  flex-wrap: wrap;
  padding-bottom: 6px;
  border-bottom: 1px solid #979797;

  &__item {
    font-size: 16px;
    font-weight: 700;
  }
}

.main {
  position: relative;
  padding: 12px 0 15px;

  &.no-button {
    padding-bottom: 0;
  }
}

.airport {
  &:last-of-type {
    text-align: right;
  }
}

.code,
.city {
  font-weight: 500;
}

.code {
  font-size: 38px;
  line-height: 1;
}

.city {
  font-size: 12px;
  text-transform: uppercase;
}

.plane-icon {
  position: absolute;
  left: 50%;
  top: 23px;
  transform: translateX(-50%);
  width: 16px;
  height: 20px;
}

.buttons {
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 1fr;

  .btn + .btn {
    margin: 0;
  }
}
</style>
